<div (click)="openDialog()" class="link-primary" fxFlex="100">
	{{ label }}
</div>
